import { createContext, useContext, useState } from 'react';
import AddSkillsModal from '../../../components/modals/AddSkillsModal';
import { usePacketBase } from './PacketBaseContext';
import { InputValidationErrorModal } from '../Modals/InputValidationErrorModal';
import { SUBJECT_MAP } from '../../../utils/skills';
import { PossibleBookMatchModal } from '../Modals/PossibleBookMatchModal';
import LoadingScreen from '../../../components/modals/LoadingScreen';
import { YoutubeTranscriptModal } from '../../../components/modals/YoutubeTranscriptModal';
import { TooManyPacketsModal } from '../Modals/TooManyPacketsModal';
import { TextLimitModal } from '../Modals/TextLimitModal';

const HomepageModalsContext = createContext({});

export const useHomepageModals = () => useContext(HomepageModalsContext);

export const HomepageModalsProvider = ({ children }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [textTooLongError, setTextTooLongError] = useState(null);
  const [inputValidationError, setInputValidationError] = useState(null);
  const [alignToTypeClicked, setAlignToTypeClicked] = useState(null);
  const [possibleBookMatch, setPossibleBookMatch] = useState(null); // {book}
  const [youtubeTranscriptModal, setYoutubeTranscriptModal] = useState(null); // { url, onTranscript }
  const [tooManyPacketsError, setTooManyPacketsError] = useState(null);

  return (
    <HomepageModalsContext.Provider
      value={{
        setAlignToTypeClicked,
        setTextTooLongError,
        setInputValidationError,
        setPossibleBookMatch,
        setIsGenerating,
        setYoutubeTranscriptModal,
        setTooManyPacketsError,
        isGenerating,
      }}>
      {isGenerating.isGenerating && <LoadingScreen customMessage={isGenerating.customMessage} />}
      {possibleBookMatch && (
        <PossibleBookMatchModal
          showModal={true}
          setShowModal={() => {
            setPossibleBookMatch(null);
          }}
          book={possibleBookMatch}
        />
      )}
      {inputValidationError && (
        <InputValidationErrorModal
          showModal={!!inputValidationError}
          setShowModal={setInputValidationError}
          error={inputValidationError}
        />
      )}
      {textTooLongError && (
        <TextLimitModal
          showModal={true}
          error={textTooLongError}
          setShowModal={setTextTooLongError}
        />
      )}
      {alignToTypeClicked && (
        <AddSkillsModalWrapper
          alignToTypeClicked={alignToTypeClicked}
          setAlignToTypeClicked={setAlignToTypeClicked}
        />
      )}
      {youtubeTranscriptModal && (
        <YoutubeTranscriptModal
          showModal={true}
          setShowModal={() => setYoutubeTranscriptModal(null)}
          youtubeUrl={youtubeTranscriptModal.url}
          onUseTranscript={(transcript) => {
            youtubeTranscriptModal.onTranscript(transcript);
            setYoutubeTranscriptModal(null);
          }}
        />
      )}
      {tooManyPacketsError && (
        <TooManyPacketsModal
          showModal={true}
          setShowModal={() => setTooManyPacketsError(null)}
          error={tooManyPacketsError}
        />
      )}
      {children}
    </HomepageModalsContext.Provider>
  );
};

const AddSkillsModalWrapper = ({ alignToTypeClicked, setAlignToTypeClicked }) => {
  const { languageStandards, setLanguageStandards, contentStandard, setContentStandard } =
    usePacketBase();

  return (
    <AddSkillsModal
      showModal={!!alignToTypeClicked}
      setShowModal={setAlignToTypeClicked}
      onSubmit={(e) => {
        const subjectKey = localStorage.getItem('skills::selectedSubject');
        const subject = subjectKey ? SUBJECT_MAP[subjectKey] : null;
        if (subject?.standardType === 'language') {
          setLanguageStandards(e.selected);
        } else {
          setContentStandard(e.selected);
        }
      }}
      selectedLanguageStandards={languageStandards}
      selectedContentStandard={contentStandard}
    />
  );
};
